// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  amplitudeApiKey: '20dd1f26648ce4c78c33dce041468c22',
  public_key: `-----BEGIN PUBLIC KEY-----
MIICIjANBgkqhkiG9w0BAQEFAAOCAg8AMIICCgKCAgEA43hlFwU4HlhCo2bSUTXQ
aYvxXrAhBbXXkGZX3maExaUFxuQCNZ+16FCcebe710KXPsz9RTA+3BYERWSJJigR
9HdLAKErc7APziaYMx7iWHm2ngUcF3gKRkCVoLRwpvV2rbgbM+NbEPXTk5tZXYN6
x+sU2HBAKxcDW2ODPr3bHXKvErfoSVUXG82V0DyWEwIYDuoFE3c95QTEV7OV/1uR
DQU9t656k8b2hhj/6hr655yyZhP4Wqp3sCZE+2jCT2Li+fh8mOfr7P7cVd1PG2lW
wFo4kUDPyZbJKPWHzaJlvK5N45PP4Q/E2IcDp2XOr+HykTczHntJX6W+paN3vVis
+2orrN6QcfSa0otYPXtvKD0/iK1QJKU4U5esvlAzUPMxxakFaE+RgNcko9AO25q4
xhx31KJWt/52iFyLoiteWHz/ALW/O6Gzkd19cmorYr1WNhEfupv8+5KDGmC9pY2G
ajE28ix19gPEuWXGcbwrJ4jG7QrpryzLECSWufidUrLSGDhrZg+T/3VSGlKFJvSJ
iew2gbk4NTt3d2RxVZXYE7PlmEFwai42V+lIQGSa1q1CCuR5Yy1vBbKSYoMptHuv
oV02qzJmDaAAjr7UNOlD7EvRqBDyReIk2pH7xZqDQDeymaemntoQErgHRQOut5R2
e1VZYtGrQIYR643YPgEXLpkCAwEAAQ==
-----END PUBLIC KEY-----`,
  originUrl: 'https://pagoappde.copec.com'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
